import { StylesProvider } from "@material-ui/styles";
import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import { LanguageContextProvider } from "./contextes/LanguageContext";
import { CustomThemeProvider } from "./contextes/ThemeContext";

ReactDOM.render(
  <React.StrictMode>
    <LanguageContextProvider>
      <StylesProvider injectFirst>
        <CustomThemeProvider>
          <App />
        </CustomThemeProvider>
      </StylesProvider>
    </LanguageContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
